import React from 'react';

// The visual anchor of the app: monospace amber plate chip
export const PlateChip = ({ plate, size = 'sm' }) => {
  if (!plate) return null;
  const sizing = size === 'lg' ? 'px-3 py-1 text-base' : 'px-2 py-0.5 text-xs';
  return (
    <span
      data-testid="plate-chip"
      className={`inline-flex items-center rounded-md border font-plate font-semibold tracking-wide tabular-nums whitespace-nowrap bg-[hsl(var(--plate-bg))] text-[hsl(var(--plate-fg))] border-[hsl(var(--plate-border))] shadow-[inset_0_1px_0_rgba(255,255,255,0.7)] ${sizing}`}
    >
      {plate}
    </span>
  );
};
